module.exports = __webpack_public_path__ + "static/media/ICON_QUICK_START_DETAIL.cf9d0c3d.png";